import a from './cpd';
import b from './dmt';

export const cpd = a;
export const dmt = b;